import React from "react";
import PropTypes from "prop-types";

import { UIChip, UIProgressBar } from "../../ui";
import { clx } from "../../../utils/Helpers";
import EntityCell from "../EntityCell";
import { getSatisfactionBand } from "./constants";
import "./SatisfactionCard.scss";

/**
 * One client's (or company's) satisfaction: avatar + name + evaluated-events
 * subtitle, the overall score with a progress bar, and a footer of the period
 * covered plus a rating chip for the score band.
 */
const SatisfactionCard = ({
  name,
  subtitle,
  imageUrl,
  score,
  overallLabel,
  footerLabel,
  bandLabels,
}) => {
  // Band by the displayed (whole) percentage, so "75%" never shows "Need attention".
  const band = getSatisfactionBand(Math.round(score));

  return (
    <article className="satisfaction-card">
      <EntityCell
        variant="client"
        size="md"
        name={name}
        subtitle={subtitle}
        imageUrl={imageUrl}
      />

      <div className="satisfaction-card__meter">
        <div className="satisfaction-card__score">
          <span className="satisfaction-card__label">{overallLabel}</span>
          <span className="satisfaction-card__value">{Math.round(score)}%</span>
        </div>

        <UIProgressBar
          value={Math.round(score)}
          color={band.tone}
          size="sm"
          trackColor="var(--color-primary-0, #F3F0FF)"
        />
      </div>

      <footer className="satisfaction-card__footer">
        {footerLabel && (
          <span className="satisfaction-card__footer-text">{footerLabel}</span>
        )}
        <UIChip
          appearance="light"
          size="small"
          color={band.chipColor}
          label={bandLabels[band.chipLabelKey]}
          className={clx(!footerLabel && "satisfaction-card__tag--alone")}
        />
      </footer>
    </article>
  );
};

SatisfactionCard.propTypes = {
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  score: PropTypes.number.isRequired,
  overallLabel: PropTypes.string.isRequired,
  footerLabel: PropTypes.string,
  bandLabels: PropTypes.objectOf(PropTypes.string).isRequired,
};

SatisfactionCard.defaultProps = {
  imageUrl: null,
  footerLabel: "",
};

export default SatisfactionCard;
